import { Button, Grid, Typography, FormControlLabel, Checkbox, RadioGroup, Radio, TextField as MuiTextField } from '@mui/material';
import { Form, Field, useFormikContext } from 'formik';
import { TextField, Autocomplete } from 'formik-mui';
import { userSchema } from '../UserContext';
import * as yup from 'yup';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { useContext } from 'react';
import { applicationContext } from 'helpers/services';


let UserForm = () => {
    let router = useLocation();

    let { userGroups } = useContext(applicationContext);

    let isNew = router.pathname.includes('/addnew');
    let title = isNew ? 'Nuovo utente' : `Modifica utente`;

    type User = yup.InferType<typeof userSchema>;
    let form = useFormikContext<User>();

    return (
        <Form>
            <Grid container>
                <Grid item xs>
                    <Typography variant="h1">{title}</Typography>
                </Grid>
            </Grid>
            <Grid container>
                <Grid item xs={12}>
                    <Field
                        component={TextField}
                        name="email"
                        type="email"
                        label="Email"
                        disabled={isNew === false}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <Field
                        component={TextField}
                        name="firstName"
                        label="Nome"
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <Field
                        component={TextField}
                        name="lastName"
                        label="Cognome"
                    />
                </Grid>
                <Grid item xs={12}>
                    <Field
                        name="groups"
                        component={Autocomplete}
                        multiple
                        size="small"
                        options={userGroups.map(x => x.key)}
                        getOptionSelected={(option: string, value: string) => option === value}
                        getOptionLabel={(option: string) => userGroups.getValueByKey(option)}
                        renderInput={(params: any) =>
                            <MuiTextField
                                {...params}
                                error={form.touched["groups"] && !!form.errors["groups"]}
                                helperText={form.errors["groups"]}
                                label="Gruppi"
                            />
                        }
                    />
                </Grid>

                <Grid item xs={12}>
                    <Typography variant="body2"><b>Utenti</b></Typography>
                    <FormControlLabel
                        label="Può gestire gli utenti Simec"
                        name="canManageSimecUsers"
                        value={form.values.canManageSimecUsers}
                        checked={form.values.canManageSimecUsers}
                        onChange={(e: any) => form.setFieldValue('canManageSimecUsers', e.target.checked)}
                        control={<Field type="checkbox" color="secondary" name="canManageSimecUsers" component={Checkbox} />}
                    />
                    <FormControlLabel
                        label="Può gestire i clienti"
                        name="canManageCustomerUsers"
                        value={form.values.canManageCustomerUsers}
                        checked={form.values.canManageCustomerUsers}
                        onChange={(e: any) => form.setFieldValue('canManageCustomerUsers', e.target.checked)}
                        control={<Field type="checkbox" color="secondary" name="canManageCustomerUsers" component={Checkbox} />}
                    />
                    <FormControlLabel
                        label="Può accedere come un altro utente"
                        name="canLoginAs"
                        value={form.values.canLoginAs}
                        checked={form.values.canLoginAs}
                        onChange={(e: any) => form.setFieldValue('canLoginAs', e.target.checked)}
                        control={<Field type="checkbox" color="secondary" name="canLoginAs" component={Checkbox} />}
                    />
                    <FormControlLabel
                        label="Può gestire utenti Simec che vanno dai clienti"
                        name="canManageCanGoToCustomerSimecUsers"
                        value={form.values.canManageCanGoToCustomerSimecUsers}
                        checked={form.values.canManageCanGoToCustomerSimecUsers}
                        onChange={(e: any) => form.setFieldValue('canManageCanGoToCustomerSimecUsers', e.target.checked)}
                        control={<Field type="checkbox" color="secondary" name="canManageCanGoToCustomerSimecUsers" component={Checkbox} />}
                    />
                </Grid>

                <Grid item xs={12}>
                    <Typography variant="body2"><b>Ticket</b></Typography>
                    <FormControlLabel
                        label="Può creare un ticket"
                        name="canCreateTicket"
                        value={form.values.canCreateTicket}
                        checked={form.values.canCreateTicket}
                        onChange={(e: any) => form.setFieldValue('canCreateTicket', e.target.checked)}
                        control={<Field type="checkbox" color="secondary" name="canCreateTicket" component={Checkbox} />}
                    />
                    <FormControlLabel
                        label="Può eliminare un ticket"
                        name="canDeleteTicket"
                        value={form.values.canDeleteTicket}
                        checked={form.values.canDeleteTicket}
                        onChange={(e: any) => form.setFieldValue('canDeleteTicket', e.target.checked)}
                        control={<Field type="checkbox" color="secondary" name="canDeleteTicket" component={Checkbox} />}
                    />
                    <br />
                    <FormControlLabel
                        label="Può essere assegnato ad un ticket"
                        name="canBeAssignedToTicket"
                        value={form.values.canBeAssignedToTicket}
                        checked={form.values.canBeAssignedToTicket}
                        onChange={(e: any) => form.setFieldValue('canBeAssignedToTicket', e.target.checked)}
                        control={<Field type="checkbox" color="secondary" name="canBeAssignedToTicket" component={Checkbox} />}
                    />
                    <FormControlLabel
                        label="Può essere reporter"
                        name="canBeReporter"
                        value={form.values.canBeReporter}
                        checked={form.values.canBeReporter}
                        onChange={(e: any) => form.setFieldValue('canBeReporter', e.target.checked)}
                        control={<Field type="checkbox" color="secondary" name="canBeReporter" component={Checkbox} />}
                    />
                    <FormControlLabel
                        label="Può gestire le richieste che arrivano in Inbox"
                        name="canManageTicketInbox"
                        value={form.values.canManageTicketInbox}
                        checked={form.values.canManageTicketInbox}
                        onChange={(e: any) => form.setFieldValue('canManageTicketInbox', e.target.checked)}
                        control={<Field type="checkbox" color="secondary" name="canManageTicketInbox" component={Checkbox} />}
                    />
                    <FormControlLabel
                        label="Può andare dal cliente"
                        name="canGoToCustomer"
                        value={form.values.canGoToCustomer}
                        checked={form.values.canGoToCustomer}
                        onChange={(e: any) => form.setFieldValue('canGoToCustomer', e.target.checked)}
                        control={<Field type="checkbox" color="secondary" name="canGoToCustomer" component={Checkbox} />}
                    />
                    <FormControlLabel
                        label="Vede la dashboard"
                        name="canViewDashboard"
                        value={form.values.canViewDashboard}
                        checked={form.values.canViewDashboard}
                        onChange={(e: any) => form.setFieldValue('canViewDashboard', e.target.checked)}
                        control={<Field type="checkbox" color="secondary" name="canViewDashboard" component={Checkbox} />}
                    />
                    <FormControlLabel
                        label="Ricevi notifica ticket con squadra chiuso"
                        name="isSubscribedToTicketDoneNotifications"
                        value={form.values.isSubscribedToTicketDoneNotifications}
                        checked={form.values.isSubscribedToTicketDoneNotifications}
                        onChange={(e: any) => form.setFieldValue('isSubscribedToTicketDoneNotifications', e.target.checked)}
                        control={<Field type="checkbox" color="secondary" name="isSubscribedToTicketDoneNotifications" component={Checkbox} />}
                    />
                    <RadioGroup
                        row
                        value={form.values.canMoveMessages}
                        onChange={e => form.setFieldValue('canMoveMessages', e.target.value)}
                    >
                        <FormControlLabel value='None' control={<Radio color="secondary" />} label="Non può spostare messaggi tra i tickets" />
                        <FormControlLabel value='Mine' control={<Radio color="secondary" />} label="Può spostare i propri messaggi tra i tickets" />
                        <FormControlLabel value='All' control={<Radio color="secondary" />} label="Può spostare tutti i messaggi tra i tickets" />
                    </RadioGroup>

                    <RadioGroup
                        row
                        value={form.values.ticketManagement}
                        onChange={e => form.setFieldValue('ticketManagement', e.target.value)}
                    >
                        <FormControlLabel value='CanView' control={<Radio color="secondary" />} label="Visualizzazione in sola lettura" />
                        <FormControlLabel value='CannotWorkOnTickets' control={<Radio color="secondary" />} label="Non lavora coi ticket" />
                        <FormControlLabel value='CanWorkOnAllTickets' control={<Radio color="secondary" />} label="Lavora in tutti i ticket" />
                    </RadioGroup>

                    <RadioGroup
                        value={form.values.ticketManagement}
                        onChange={e => form.setFieldValue('ticketManagement', e.target.value)}
                    >
                        <FormControlLabel value='CanWorkOnMyTickets' control={<Radio color="secondary" />} label="Lavora solo nei ticket aperti dall'utente, assegnati all'utente, con l'utente in squadra o dei quali è il reporter" />
                        <FormControlLabel value='CanWorkOnTicketForMyGroup' control={<Radio color="secondary" />} label="Lavora solo nei ticket in cui è presente almeno uno dei gruppi dell'utente, aperti dall'utente o dei quali è il reporter" />
                    </RadioGroup>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="body2"><b>Persone</b></Typography>
                    <RadioGroup
                        row
                        value={form.values.schedulingManagement}
                        onChange={e => form.setFieldValue('schedulingManagement', e.target.value)}
                    >
                        <FormControlLabel value='None' control={<Radio color="secondary" />} label="Pianificazione/Assenze non visibili" />
                        <FormControlLabel value='ReadOnlyScheduling' control={<Radio color="secondary" />} label="Può vedere pianificazione/assenze" />
                        <FormControlLabel value='EditScheduling' control={<Radio color="secondary" />} label="Può vedere e modificare pianificazione/assenze" />
                    </RadioGroup>

                    <FormControlLabel
                        label="Può vedere il report"
                        name="canViewSummary"
                        value={form.values.canViewSummary}
                        checked={form.values.canViewSummary}
                        onChange={(e: any) => form.setFieldValue('canViewSummary', e.target.checked)}
                        control={<Field type="checkbox" color="secondary" name="canViewSummary" component={Checkbox} />}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="body2"><b>Categorie ticket</b></Typography>
                    <FormControlLabel
                        label="Può modificare le categorie dei ticket"
                        name="canManageTicketCategories"
                        value={form.values.canManageTicketCategories}
                        checked={form.values.canManageTicketCategories}
                        onChange={(e: any) => form.setFieldValue('canManageTicketCategories', e.target.checked)}
                        control={<Field type="checkbox" name="canManageTicketCategories" component={Checkbox} color="secondary" />}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="body2"><b>Tipologie di strumenti</b></Typography>
                    <FormControlLabel
                        label="Può gestire le tipologie di strumenti"
                        name="canManageToolTypologies"
                        value={form.values.canManageToolTypologies}
                        checked={form.values.canManageToolTypologies}
                        onChange={(e: any) => form.setFieldValue('canManageToolTypologies', e.target.checked)}
                        control={<Field type="checkbox" name="canManageToolTypologies" component={Checkbox} color="secondary" />}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="body2"><b>Strumenti</b></Typography>
                    <FormControlLabel
                        label="Può gestire gli strumenti"
                        name="canManageTools"
                        value={form.values.canManageTools}
                        checked={form.values.canManageTools}
                        onChange={(e: any) => form.setFieldValue('canManageTools', e.target.checked)}
                        control={<Field type="checkbox" name="canManageTools" component={Checkbox} color="secondary" />}
                    />
                    <FormControlLabel
                        label="Riceve le notifiche di manutenzione degli strumenti"
                        name="isSubscribedToToolMaintenanceNotifications"
                        value={form.values.isSubscribedToToolMaintenanceNotifications}
                        checked={form.values.isSubscribedToToolMaintenanceNotifications}
                        onChange={(e: any) => form.setFieldValue('isSubscribedToToolMaintenanceNotifications', e.target.checked)}
                        control={<Field type="checkbox" name="isSubscribedToToolMaintenanceNotifications" component={Checkbox} color="secondary" />}
                    />
                </Grid>

            </Grid>
            <Grid container>
                <Grid item xs />
                <Grid item>
                    <Button
                        component={RouterLink}
                        variant="outlined"
                        color="secondary"
                        to={"/users"}
                    >
                        Annulla
                    </Button>
                    <Button type="submit" variant="contained">
                        Salva
                    </Button>
                </Grid>
            </Grid>
        </Form>
    );
}

export default UserForm;